import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Rating from "../sidebar/rating";
import { useRef } from "react";
import rimage from "../../assets/images/art/profile_image.jpg";
 
const subTitle = "Meet Our Top Artists & Tutors";
const title = "Learn From Certified Professionals in Dance, Music, Drama & Arts";
 
 
 
const Instructor = () => {
    const [tutors, setTutors] = useState([]);
    const [tutor,setTutor] = useState([]);
    const sliderRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
   const [ads, setAds] = useState([]);

 
const scrollLeft = () => {
    // Scroll by the width of the container/card to ensure one full scroll per click
    const cardWidth = sliderRef.current.querySelector(".tutor-card").offsetWidth;
    const gap = 20; // Must match the CSS gap value
    sliderRef.current.scrollBy({
        left: -(cardWidth + gap), // Scroll left by one card width + gap
        behavior: "smooth"
    });
    // This active index logic might need a more robust solution for fractional scrolling,
    // but we'll keep it simple for now based on your original logic.
    setActiveIndex((prev) => Math.max(prev - 1, 0));
 
 
};
 
    const fullName = tutor?.tutor_type === "individual"
    ? tutor?.full_name || "General"
    : tutor?.owner_name || "General";
    const title = tutor?.category || "Creative Professional";
    const profilePhotoUrl = tutor?.profile_photo 
        ? `https://kalakakshaaha.com/uploads/tutors/${tutor.profile_photo}` 
        : rimage;


const scrollRight = () => {
    // Scroll by the width of the container/card to ensure one full scroll per click
    const cardWidth = sliderRef.current.querySelector(".tutor-card").offsetWidth;
    const gap = 20; // Must match the CSS gap value
    sliderRef.current.scrollBy({
        left: (cardWidth + gap), // Scroll right by one card width + gap
        behavior: "smooth"
    });
    // This active index logic might need a more robust solution for fractional scrolling,
    // but we'll keep it simple for now based on your original logic.
    setActiveIndex((prev) => Math.min(prev + 1, tutors.length - 1));
 
 
};
 
 useEffect(() => {
  fetch("https://kalakakshaaha.com/kks/api/v1/pages")
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setAds(data.pages);
      }
    })
    .catch(err => console.error("Ads fetch error:", err));
}, []);

  useEffect(() => {
    fetch("https://kalakakshaaha.com/kks/api/tutors")
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
 
                // Sort by plan → premium first, then silver, then basic
               const sorted=data.tutors.sort((a, b) => {
               const order = { premium: 1, silver: 2, basic: 3 };
                 return (order[a.membership_plan] || 4) - (order[b.membership_plan] || 4);
                });
 
                // Keep ONLY top 10
                const topTen = sorted.slice(0, 10);
 
                setTutors(topTen);
            }
        });
}, []);


//for fetching skills
const [allSkills, setAllSkills] = useState([]);
 
useEffect(() => {
  fetch("https://kalakakshaaha.com/kks/api/v1/total-skills")
    .then(res => res.json())
    .then(data => {
      if (data.success) setAllSkills(data.skills);  // [{id:1, skill_title:"Guitar"}]
    })
    .catch(err => console.log("Skills fetch error:", err));
}, []);
 
const getSkillName = (id) => {
  const s = allSkills.find(sk => Number(sk.id) === Number(id));
  return s ? s.skill_title : "";
};
 
 
    return (
        <div
            className="instructor-section padding-tb section-bg"
            style={{ background: "transparent" }}
        >
            {/* ---------- INLINE CSS (Modified UI for Mobile) ---------- */}
            <style>{`
                 /* --- Existing CSS (Unmodified) --- */
                .instructor-card {
                    width: 260px;
                    height: 400px;
                    display: flex;
                    flex-direction: column;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.08);
                }
 
                .img-wrap {
                    width: 100%;
                    height: 220px;
                    overflow: hidden;
                    position: relative;
                    border-radius: 12px 12px 0 0;
                }
 
                .img-wrap img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.6s ease;
                }
 
                .img-wrap:hover img {
                    transform: scale(1.12);
                }
 
                .instructor-content {
                    padding: 18px;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                    justify-content: flex-start;
                }
 
                .instructor-content h4 {
                    font-size: 20px;
                    font-weight: 700;
                    margin-bottom: 8px;
                    color: #222;
                }
 
                .designation {
                    font-size: 15px;
                    font-weight: 600;
                    color: #444;
                    margin-bottom: 2px;
                }
 
                .experience {
                    font-size: 14px;
                    color: #666;
                    margin-bottom: 5px;
                }
 
                .rating-block {
                    margin-top: auto;
                    padding-top: 5px;
                    color: #f5a623;
 
                }
                .tutor-slider-container {
                    position: relative;
                    width: 100%;
                    padding: 20px 40px; /* Space for buttons */
                }
 
                .tutor-slider {
                    display: flex;
                    gap: 20px;
                    overflow-x: auto;
                    scroll-behavior: smooth;
                    padding-bottom: 10px;
                }
 
                .tutor-slider::-webkit-scrollbar {
                    display: none;
                }
 
                .tutor-card {
                    min-width: 260px; /* Default for larger screens */
                    flex: 0 0 auto;
 
                }
 
                .slide-btn {
                    position: absolute;
                    top: 45%;
                    transform: translateY(-50%);
                    background: #f2efeefe;
                    border: none;
                    font-size: 28px;
                    cursor: pointer;
                    padding: 8px 14px;
                    border-radius: 50%;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.3);
                    z-index: 10;
                    height:60px;
                    width:60px
                }
 
                .slide-btn.left {
                    left: 0;
                }
 
                .slide-btn.right {
                    right: 0;
                }
 
                .slide-btn:hover {
                    background: #ffffffff;
                }
             
                .tutor-card {
                    min-width: 250px;  
                    flex: 0 0 auto;
                    position: relative;
                }
 
 
                .rank-on-image {
                    position: absolute;
                    top: 12px;
                    right: 12px;
                    background: linear-gradient(135deg, #ff2d6d, #ff7a00);
                    color: #fff;
                    font-weight: 900;
                    font-size:18px;
                    padding: 8px 5px;
                    z-index: 12;
                    box-shadow: 0 6px 18px rgba(0,0,0,0.35);
                    border-radius:4px;
                    transform-origin: center;
                    transition: transform 0.28s ease;
                    pointer-events: none;
                }
 
                .tutor-card:hover .rank-on-image {
                    transform: scale(1.15);
                }
 
                .instructor-scroller .tutor-card {
                    width: 260px;
                    height:420px !important;
                    background: white;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0px 4px 14px rgba(0,0,0,0.12);
                }

    /* ---------- WIDE AD STRIP ---------- */
    .promo-strip {
    width: 100%;
    margin-bottom: 40px;
    }

.promo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  justify-items: center;
}


.promo-img {
  width: 420px;
  height: 180px;      /* STANDARD SIZE */
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.35);
  transition: transform 0.3s ease;
  flex: 0 0 auto;
}

    .promo-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    }

    .promo-img:hover {
    transform: translateY(-4px);
    }

    /* Mobile */
@media (max-width: 768px) {
  .promo-grid {
    grid-template-columns: 1fr;
  }
}
.promo-img img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* show full banner */
}


    }


    /* Mobile */
    @media (max-width: 768px) {
    .promo-inner {
        flex-direction: column;
        text-align: center;
        gap: 12px;
    }

    .promo-left img {
        width: 70px;
    }
    }

                .tutor-card:hover {
                    box-shadow: 0px 8px 24px rgba(0,0,0,0.2);
                    border-radius:12px;
 
                }
               
                /* --- NEW MOBILE CSS ADDED HERE --- */
                @media (max-width: 768px) {
                    /* This makes the tutor-slider-container take up the full screen width
                       minus padding and ensures the buttons are reachable. */
                    .tutor-slider-container {
                        padding: 20px 10px; /* Reduced side padding for small screens */
                    }
                   
                    /* This is the key change: make the card take up 100% of the container width */
                    .tutor-card {
                        min-width: calc(100% - 20px); /* 100% of container width minus 20px of gap */
                        width: calc(100% - 20px);
                        flex-shrink: 0; /* Important: prevents shrinking */
                    }
                   
                    /* Adjust button position slightly for smaller screens */
                    .slide-btn.left {
                        left: -5px;
                    }
 
                    .slide-btn.right {
                        right: -5px;
                    }
                }
                /* ---------------------------------- */


                /* ================= PROMO ADS – MOBILE SAFE ================= */

.promo-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  justify-items: center;
}

/* AD CARD */
.promo-img {
  width: 100%;
  max-width: 420px;
  aspect-ratio: 16 / 7;     /* desktop banner */
  overflow: hidden;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(0,0,0,0.25);
}

.promo-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;       /* always fills nicely */
}

/* ---------- TABLET ---------- */
@media (max-width: 1024px) {
  .promo-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* ---------- MOBILE (IMPORTANT FIX) ---------- */
@media (max-width: 768px) {
  .promo-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .promo-img {
    max-width: 100%;
    aspect-ratio: 16 / 9;     /* 🔥 mobile banner */
    max-height: 180px;        /* 🔒 prevents tall ads */
  }

  .promo-img img {
    object-fit: cover;        /* avoids white space */
  }
}

/* ---------- SMALL MOBILE ---------- */
@media (max-width: 480px) {
  .promo-img {
    max-height: 160px;
  }
}
/* ===== FIX ENQUIRY FORM MOBILE CUT ===== */
@media (max-width: 768px) {

  .enquiry-section,
  .enquire-section,
  .enquiry-wrapper {
    height: auto !important;
    min-height: unset !important;
    overflow: visible !important;
  }

  /* If enquiry is inside a card */
  .fun-card,
  .enquiry-card {
    height: auto !important;
    min-height: unset !important;
  }

}
@media (max-width: 768px) {

  .enquiry-form {
    padding-bottom: 24px;
  }

  .enquiry-form input,
  .enquiry-form textarea,
  .enquiry-form button {
    width: 100%;
  }

}

 @media (max-width: 768px) {
  .page-hero,
  .banner-section {
    min-height: auto;
    padding-bottom: 30px;
  }
}

            `}</style>


            {/* ---------- PROMO AD STRIP ---------- */}
{/* ---------- 3 AD STRIP BANNERS ---------- */}
<div className="container">
  <div className="promo-strip">
    <div className="promo-grid">

      {ads.map((ad) => (
        <Link
          key={ad.id}
          to={`/page/${ad.url_slug}`}
          className="promo-img"
        >
          <img
           src={`https://kalakakshaaha.com/uploads/pages/${ad.image}`}
            alt={ad.title}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = rimage; // fallback image
            }}
          />
        </Link>
      ))}

    </div>
  </div>
</div>



 
            <div className="container">
                <div className="section-header text-center">
                   <span style={{ fontSize: "25px", fontWeight: "bold", color: "orange"}}>{subTitle}</span>
 
                    <h2 className="title" style={{ color: "white" }}>{title}</h2>
                </div>
 
                <div className="section-wrapper instructor-scroller" >
                    <div className="tutor-slider-container">
    <button className="slide-btn left" onClick={scrollLeft}>❮</button>
 
    <div className="tutor-slider" ref={sliderRef}>
        {tutors.map((tutor, index) => (
<div className={`tutor-card ${activeIndex === index ? "active-card" : ""}`} key={index}>
    <Link
        to={`/tutor/${(tutor.full_name || "tutor").toLowerCase().replace(/\s+/g, "-")}-${tutor.city_id}?id=${tutor.user_id}`}

        
        style={{ textDecoration: "none", color: "inherit" }}
    >
        <div className="img-wrap">
<img
  src={
    tutor.profile_photo
      ? `https://kalakakshaaha.com/uploads/tutors/${tutor.profile_photo}`
      : rimage
  }
  alt={tutor.full_name}
  onError={(e) => {
    e.target.onerror = null;
    e.target.src = rimage;
  }}
/>

 
            <div className={` ${activeIndex === index ? "active" : ""}`}>
              
            </div>
        </div>
 
        <div className="instructor-content">
            <h4>{tutor.full_name}</h4>
            {/* <p className="designation">{tutor.skills
    .split(",")
    .map(id => getSkillName(id))
    .join(", ")}</p> */}
           
            <p className="experience">
                {tutor.experience ? `${tutor.experience}+ Years Experience` : "Experience Not Provided"}
            </p>
 
            <div className="rating-block">
                <Rating />
            </div>
        </div>
    </Link>
</div>
 
        ))}
    </div>
 
    <button className="slide-btn right" onClick={scrollRight}>❯</button>
</div>
 
                </div>
            </div>  
        </div>
    );
};
 
export default Instructor;
 